import React, { Fragment } from 'react'
import { string, shape, arrayOf } from 'prop-types'
import classNames from 'src/common/helpers/class-names'
import { WasPrice, Price, PricePerUOM } from 'shared/interim/product'
import { BLOCK as blk, UNAVAILABLE_BLOCK as unavailableBlk, PILL_BLOCK as pillBlk } from './constants'

const PriceQuantity = (props) => {
  const { mods, item } = props

  const {
    priceDetails,
    promoDetails: { type = '' },
  } = item

  const {
    unit = '', wasPrice, shouldHidePrice, isUnavailable, availability,
  } = priceDetails
  const promoType = type.toLowerCase()
  const unitType = unit.toLowerCase()
  const isRollbackOrSale =
    ['rollback', 'sale'].indexOf(promoType) > -1 && !!wasPrice
  const pricePerUomElt = 'price-per-uom-msg'

  const getUnavailText = (stockType) => {
    const statusMap = {
      O: 'OUT OF STOCK',
      I: 'ITEM UNAVAILABLE',
      C: 'COMING SOON',
    }
    return statusMap[stockType] || ''
  }

  const UnAvailText = getUnavailText(availability)

  const UnAvailEltClass = classNames({
    blk: pillBlk,
    className: classNames({ blk: unavailableBlk, elt: 'product-status' }),
    mods: ['light'],
  })

  const unavailable = (
    <Fragment>
      <div className='unavailable-banner'>
        <span className={UnAvailEltClass}>{UnAvailText || 'ITEM UNAVAILABLE'}</span>
      </div>
    </Fragment>
  )

  if (shouldHidePrice) {
    return (<Fragment> <div className={classNames({ blk, elt: 'price-container' })} /> {unavailable} </Fragment>)
  }

  return (
    <Fragment>
      <div className={classNames({ blk, elt: 'price-container', mods })}>
        {isRollbackOrSale && ['each', 'weighted'].indexOf(unitType) > -1 && (
          <div>
            <WasPrice {...priceDetails} />
            <Price {...priceDetails} />
            <p className={classNames({ blk, elt: pricePerUomElt })}>
              <PricePerUOM {...priceDetails} />
            </p>
          </div>
        )}
        {isRollbackOrSale && unitType === 'both' && (
          <span className={classNames({ blk, elt: 'price-per-uom' })}>
            <Price {...priceDetails} />{' '}
            <p className={classNames({ blk, elt: pricePerUomElt })}>
              <WasPrice {...priceDetails} showUom />
              <PricePerUOM {...priceDetails} />
            </p>
          </span>
        )}
        {!isRollbackOrSale && (
          <span className={classNames({ blk, elt: 'price-per-uom' })}>
            <Price {...priceDetails} />
            <p className={classNames({ blk, elt: pricePerUomElt })}>
              <PricePerUOM {...priceDetails} />
            </p>
          </span>
        )}
      </div>
      {isUnavailable && unavailable}
    </Fragment>
  )
}

PriceQuantity.propTypes = {
  item: shape({ id: string }).isRequired,
  mods: arrayOf(string),
}

PriceQuantity.defaultProps = {
  mods: [],
}

export default PriceQuantity



// WEBPACK FOOTER //
// ./shared/interim/product-list/item/price-quantity.js